import { helper } from '@ember/component/helper';

/**
 * Coerces a numeric string to a number so it can be compared with Ember's
 * built-in `gt`/`gte`/`lt`/`lte` helpers, which require both operands to share
 * one type and reject `undefined`.
 *
 * The API serves decimal columns as strings to avoid float precision loss
 * (`FloatAsString` in `tio-data/types`), so a template that wants to ask
 * "is this amount positive?" has to convert first:
 *
 * ```gts
 * {{#if (gt (toNumber @insights.defermentDeltaPerMonth) 0)}}
 * ```
 *
 * Missing or unparsable input yields `0`, not `NaN` — so a comparison reads
 * false instead of propagating NaN through the template.
 */
export default helper(function toNumber([value]: [string | number | null | undefined]) {
  const parsed = Number(value ?? 0);
  return Number.isFinite(parsed) ? parsed : 0;
});
